import React from "react";
import { Tooltip } from "@mui/material";
import { createStyles, makeStyles, Theme } from "@material-ui/core";
import "./style.scss";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import useDesktopSize from "../../utils/hooks/useDesktopSize";

interface IProps {
  text: string;
  placement:
    | "bottom-end"
    | "bottom-start"
    | "bottom"
    | "left-end"
    | "left-start"
    | "left"
    | "right-end"
    | "right-start"
    | "right"
    | "top-end"
    | "top-start"
    | "top";
  children: any;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    customWidth: {
      width: 300
      // backgroundColor: "#b3ce61"
    }
  })
);

const tooltipText = (text: string) => {
  return (
    <div className={"tooltip-container"}>
      <p>{text}</p>
    </div>
  );
};

const TooltipCustom: React.FC<IProps> = ({ text, placement, children }: IProps) => {
  const isDesktop = useDesktopSize();
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };
  return (
    <>
      {isDesktop ? (
        <Tooltip title={tooltipText(text)} placement={placement} arrow classes={{ tooltip: classes.customWidth }}>
          {children}
        </Tooltip>
      ) : (
        <ClickAwayListener onClickAway={handleTooltipClose}>
          <Tooltip
            title={tooltipText(text)}
            placement={placement}
            arrow
            classes={{ tooltip: classes.customWidth }}
            PopperProps={{
              disablePortal: true
            }}
            onClose={handleTooltipClose}
            open={open}
            disableFocusListener
            disableHoverListener
            disableTouchListener
          >
            <div onClick={handleTooltipOpen}>{children}</div>
          </Tooltip>
        </ClickAwayListener>
      )}
    </>
  );
};

export default TooltipCustom;
